@if (pbBasket(); as basket) {
  <section class="employee-basket-card employee-pb-basket-info">
    <header class="employee-basket-card__header">
      <mat-icon class="employee-basket-card__dot" [style.color]="wls.primaryColor">lens</mat-icon>
      <h2 class="employee-basket-card__title" [style.color]="wls.accentColor">
        {{ 'financing-plans.primes-and-bonuses' | translate }}
      </h2>
    </header>

    <div class="employee-basket-card__available-label">
      {{ 'employee.basket.available-budget' | translate | uppercase }}
    </div>
    <div class="employee-basket-card__available-amount fo-mb-15">
      {{ basket.RemainingBudget | flexyooNumber: 'currency' : false }}
    </div>

    <flexyoo-employee-basket-progress-bar
      [color]="wls.accentColor"
      [total]="basket.CalculatedMaxBudget"
      [used]="basket.CalculatedSpentBudget"
    />

    <div class="employee-pb-basket-info__budget-labels">
      <span>
        {{ 'employee.basket.used-budget' | translate }}
        {{ basket.CalculatedSpentBudget | flexyooNumber: 'currency' : false }}
      </span>
      <span>
        {{ 'employee.basket.total-budget' | translate }}
        {{ basket.CalculatedMaxBudget | flexyooNumber: 'currency' : false }}
      </span>
    </div>

    @if (stats()?.fundings?.length) {
      <mat-expansion-panel
        class="employee-basket-card__expansion"
        togglePosition="before"
        [expanded]="fundingsExpanded()"
        (expandedChange)="fundingsExpanded.set($event)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title [style.color]="wls.primaryColor">
            {{ 'employee.basket.funding-types' | translate | uppercase }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <flexyoo-employee-basket-fundings-list [fundings]="stats()!.fundings" />
      </mat-expansion-panel>
    }
  </section>
}
